import { RiseOutlined } from '@ant-design/icons';
import { Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { SalesRecentAchievement } from '../../../types/dashboard';

const { Title, Text } = Typography;

interface SalesDetailRecentAchievementsProps {
  achievements: SalesRecentAchievement[] | null;
  loading: boolean;
  glassTableContainerStyle: React.CSSProperties;
}

const SalesDetailRecentAchievements: React.FC<SalesDetailRecentAchievementsProps> = ({
  achievements,
  loading,
  glassTableContainerStyle
}) => {
  const achievementColumns = [
    {
      title: 'Nama Prospek',
      dataIndex: 'lead_name',
      key: 'lead_name',
      render: (text: string) => <Text strong>{text}</Text>
    },
    {
      title: 'Pembeli (KTP)',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      render: (text: string) => <Text style={{ color: '#475569' }}>{text || '-'}</Text>
    },
    {
      title: 'Wilayah',
      dataIndex: 'area_name',
      key: 'area_name',
      render: (text: string) => <Tag color="cyan">{text}</Tag>
    },
    {
      title: 'Nominal Omzet',
      dataIndex: 'omzet_rupiah',
      key: 'omzet_rupiah',
      align: 'right' as const,
      render: (text: string) => <Text strong style={{ color: '#7BAA18' }}>{text}</Text>
    },
    {
      title: 'Tanggal Valid',
      dataIndex: 'processed_at',
      key: 'processed_at',
      render: (text: string) => <Text type="secondary" style={{ fontSize: '12px' }}>{dayjs(text).format('DD MMM YYYY, HH:mm')}</Text>
    }
  ];

  return (
    <div className="glass-table-container" style={{ ...glassTableContainerStyle, marginTop: '20px', padding: '20px 24px' }}>
      <Title level={5} style={{ color: '#1e293b', fontWeight: 700, margin: '0 0 16px 0' }}>
        <RiseOutlined style={{ color: '#52c41a', marginRight: '8px' }} />
        10 Transaksi Closing (OK) Terbaru
      </Title>
      <Table
        dataSource={achievements || []}
        columns={achievementColumns}
        rowKey="lead_id"
        pagination={false}
        loading={loading}
        size="middle"
        bordered={false}
        style={{ background: 'transparent' }}
        className="glass-table"
      />
    </div>
  );
};

export default SalesDetailRecentAchievements;
